import script from "./edit-delta.vue?vue&type=script&lang=jsx"
export * from "./edit-delta.vue?vue&type=script&lang=jsx"

import "./edit-delta.vue?vue&type=style&index=0&id=530839ec&lang=scss"

const __exports__ = script;

export default __exports__